import React from 'react';
import styles from './SendMessageStep.module.css';
import { EmailSetup } from './email-setup';
import { SMSSetup } from './SMSSetup';
import { MergeFields } from './MergeFields';
import type { SendMessageFormField } from './types';
import type { SenderDetailsUpdate } from './types';

interface SendMessageFormProps {
  subject: string;
  previewText: string;
  html: string;
  css: string;
  text: string;
  onChange: (field: SendMessageFormField, value: string | boolean) => void;
  senderProfileId: string | null | undefined;
  usePointOfContactSender?: boolean;
  onSenderProfileChange: (update: SenderDetailsUpdate) => void;
}

export const SendMessageForm: React.FC<SendMessageFormProps> = ({
  subject,
  previewText,
  html,
  css,
  text,
  onChange,
  senderProfileId,
  usePointOfContactSender,
  onSenderProfileChange,
}) => (
  <form className={styles.form}>
    <EmailSetup
      subject={subject}
      previewText={previewText}
      html={html}
      css={css}
      onSubjectChange={value => onChange('subject', value)}
      onPreviewTextChange={value => onChange('previewText', value)}
      senderProfileId={senderProfileId}
      usePointOfContactSender={usePointOfContactSender}
      onSenderProfileChange={onSenderProfileChange}
    />
    <SMSSetup defaultValue={text} onChange={value => onChange('text', value)} />
    <MergeFields />
  </form>
);
